// Decorative abstract automation/dataflow SVG for hero and section accents
export default function DataFlowGraphic({ className = "" }) {
  return (
    <svg viewBox="0 0 600 420" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="dfg-line" x1="0" y1="0" x2="600" y2="420" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#6D4DFF" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#00D4FF" stopOpacity="0.9" />
        </linearGradient>
        <linearGradient id="dfg-fill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#6D4DFF" stopOpacity="0.18" />
          <stop offset="100%" stopColor="#00D4FF" stopOpacity="0.05" />
        </linearGradient>
        <radialGradient id="dfg-node" cx="0.5" cy="0.5" r="0.6">
          <stop offset="0%" stopColor="#00D4FF" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#00D4FF" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* curved pipeline rails */}
      <path d="M20 360 C 140 320, 200 220, 320 200 S 520 160, 580 80" stroke="url(#dfg-line)" strokeWidth="1.4" />
      <path d="M20 380 C 160 360, 240 280, 360 260 S 540 220, 580 140" stroke="url(#dfg-line)" strokeWidth="1.4" opacity="0.55" />
      <path d="M20 340 C 120 310, 180 250, 280 220 S 480 170, 580 100" stroke="url(#dfg-line)" strokeWidth="1" opacity="0.4" />

      {/* lifecycle nodes */}
      {[
        { cx: 80, cy: 350, r: 28, label: "Capture" },
        { cx: 200, cy: 260, r: 32, label: "Score" },
        { cx: 330, cy: 200, r: 36, label: "Route" },
        { cx: 460, cy: 150, r: 32, label: "Nurture" },
        { cx: 560, cy: 90, r: 28, label: "Pipeline" },
      ].map((n, i) => (
        <g key={i}>
          <circle cx={n.cx} cy={n.cy} r={n.r + 22} fill="url(#dfg-node)" />
          <circle cx={n.cx} cy={n.cy} r={n.r} fill="#0B1727" stroke="url(#dfg-line)" strokeWidth="1.4" />
          <text x={n.cx} y={n.cy + 4} textAnchor="middle" fontSize="10" fontFamily="IBM Plex Mono" fill="#F7F9FC" letterSpacing="0.12em">
            {n.label.toUpperCase()}
          </text>
        </g>
      ))}

      {/* CRM/Adobe Marketo Engage cards */}
      <g>
        <rect x="40" y="40" width="170" height="74" rx="10" fill="#0B1727" stroke="url(#dfg-line)" strokeWidth="1.2" />
        <text x="56" y="64" fontFamily="IBM Plex Mono" fontSize="10" fill="#94A3B8" letterSpacing="0.16em">MARKETO ENGAGE</text>
        <text x="56" y="92" fontFamily="Space Grotesk" fontSize="18" fontWeight="600" fill="#F7F9FC">Lifecycle synced</text>
        <rect x="56" y="100" width="48" height="6" rx="2" fill="url(#dfg-fill)" stroke="url(#dfg-line)" strokeWidth="0.8"/>
      </g>
      <g>
        <rect x="390" y="320" width="170" height="74" rx="10" fill="#0B1727" stroke="url(#dfg-line)" strokeWidth="1.2" />
        <text x="406" y="344" fontFamily="IBM Plex Mono" fontSize="10" fill="#94A3B8" letterSpacing="0.16em">SALESFORCE</text>
        <text x="406" y="372" fontFamily="Space Grotesk" fontSize="18" fontWeight="600" fill="#F7F9FC">Routed in 38s</text>
        <rect x="406" y="380" width="64" height="6" rx="2" fill="url(#dfg-fill)" stroke="url(#dfg-line)" strokeWidth="0.8"/>
      </g>
    </svg>
  );
}
